import babyFormulaImage from "./assets/products/baby-formula.jpg";
import babyToiletriesImage from "./assets/products/baby-toiletries.jpg";
import babyWipesImage from "./assets/products/baby-wipes.jpg";
import bodyWashImage from "./assets/products/body-wash.jpg";
import coffeeDrinksImage from "./assets/products/coffee-drinks.jpg";
import diapersImage from "./assets/products/diapers.jpg";
import dishwashingLiquidImage from "./assets/products/dishwashing-liquid.jpg";
import eHailingImage from "./assets/products/e-hailing.jpg";
import eggsImage from "./assets/products/eggs.jpg";
import everydayBasicsImage from "./assets/products/everyday-basics.jpg";
import familyMealsImage from "./assets/products/family-meals.jpg";
import floorCleanerImage from "./assets/products/floor-cleaner.jpg";
import freshMilkImage from "./assets/products/fresh-milk.jpg";
import fuelImage from "./assets/products/fuel.jpg";
import homeInternetImage from "./assets/products/home-internet.jpg";
import lunchDealsImage from "./assets/products/lunch-deals.jpg";
import mobileDataImage from "./assets/products/mobile-data.jpg";
import prepaidTopUpImage from "./assets/products/prepaid-top-up.jpg";
import publicTransportPassImage from "./assets/products/public-transport-pass.jpg";
import schoolUniformsImage from "./assets/products/school-uniforms.jpg";
import shampooImage from "./assets/products/shampoo.jpg";
import skincareImage from "./assets/products/skincare.jpg";
import toothpasteImage from "./assets/products/toothpaste.jpg";
import workwearImage from "./assets/products/workwear.jpg";
import coffeeImage from "./assets/demand-products/coffee.jpg";
import cookingOilImage from "./assets/demand-products/cooking-oil.jpg";
import instantNoodlesImage from "./assets/demand-products/instant-noodles.jpg";
import laundryDetergentImage from "./assets/demand-products/laundry-detergent.jpg";
import riceImage from "./assets/demand-products/rice.jpg";
import tissueImage from "./assets/demand-products/tissue.jpg";

const catalogueProductImages: Record<string, string> = {
  "Alcoholic Beverages": "/product-images/alcoholic-beverages.jpg",
  "Bath & Body Wash": "/product-images/bath-body-wash.jpg",
  "Breads & Bakery": "/product-images/breads-bakery.jpg",
  "Cereals & Breakfast Foods": "/product-images/cereals-breakfast-foods.jpg",
  "Canned & Preserved Foods": "/product-images/canned-preserved-foods.jpg",
  "Chips, Nuts & Seeds": "/product-images/chips-nuts-seeds.jpg",
  "Chocolates & Sweets": "/product-images/chocolates-sweets.jpg",
  "Home Cleaning Supplies": "/product-images/home-cleaning-supplies.jpg",
  "Coffee, Tea & Infusions": "/product-images/coffee-tea-infusions.jpg",
  "Biscuits & Confectionery": "/product-images/biscuits-confectionery.jpg",
  "Cooking Oils & Fats": "/product-images/cooking-oils-fats.jpg",
  "Baby Diapers & Care": "/product-images/baby-diapers-care.jpg",
  "Beverages & Refreshments": "/product-images/beverages-refreshments.jpg",
  "Small Home Appliances": "/product-images/small-home-appliances.jpg",
  "Pantry Staples": "/product-images/pantry-staples.jpg",
  "Hair Care & Styling": "/product-images/hair-care-styling.jpg",
  "Household Essentials": "/product-images/household-essentials.jpg",
  "Pest & Insect Control": "/product-images/pest-insect-control.jpg",
  "Instant Beverage Mixes": "/product-images/instant-beverage-mixes.jpg",
  "Noodles, Pasta & Quick Meals": "/product-images/noodles-pasta-quick-meals.jpg",
  "Laundry Care": "/product-images/laundry-care.jpg",
  "Health & Remedies": "/product-images/health-remedies.jpg",
  "Ready-to-Drink Milk": "/product-images/ready-to-drink-milk.jpg",
  "Powdered Milk & Formula": "/product-images/powdered-milk-formula.jpg",
  "Oral Care": "/product-images/oral-care.jpg",
  "Paper Goods & Tissue": "/product-images/paper-goods-tissue.jpg",
  "Fragrances & Deodorants": "/product-images/fragrances-deodorants.jpg",
  "Pet Food & Supplies": "/product-images/pet-food-supplies.jpg",
  "Feminine Hygiene": "/product-images/feminine-hygiene.jpg",
  "Sauces & Condiments": "/product-images/sauces-condiments.jpg",
  "Seasonings & Flavour Enhancers": "/product-images/seasonings-flavour-enhancers.jpg",
  "Skin Care & Beauty": "/product-images/skin-care-beauty.jpg",
  "Savoury Snacks": "/product-images/savoury-snacks.jpg",
  "Breakfast Spreads": "/product-images/breakfast-spreads.jpg",
};

let databaseProductImages: Record<string, string> = {};

const normalizeImageKey = (value: string) => value.trim().replace(/\s+/g, " ").toLocaleLowerCase();

const productImages: Record<string, string> = {
  ...catalogueProductImages,
  "Baby formula": babyFormulaImage,
  "Baby toiletries": babyToiletriesImage,
  "Baby wipes": babyWipesImage,
  "Body wash": bodyWashImage,
  Coffee: coffeeImage,
  "Coffee & drinks": coffeeDrinksImage,
  "Cooking oil": cookingOilImage,
  Diapers: diapersImage,
  "Dishwashing liquid": dishwashingLiquidImage,
  "E-hailing": eHailingImage,
  Eggs: eggsImage,
  "Everyday basics": everydayBasicsImage,
  "Family meals": familyMealsImage,
  "Floor cleaner": floorCleanerImage,
  "Fresh milk": freshMilkImage,
  Fuel: fuelImage,
  "Home internet": homeInternetImage,
  "Instant noodles": instantNoodlesImage,
  "Laundry detergent": laundryDetergentImage,
  "Lunch deals": lunchDealsImage,
  "Mobile data": mobileDataImage,
  "Prepaid top-up": prepaidTopUpImage,
  "Public transport pass": publicTransportPassImage,
  Rice: riceImage,
  "School uniforms": schoolUniformsImage,
  Shampoo: shampooImage,
  Skincare: skincareImage,
  Tissue: tissueImage,
  Toothpaste: toothpasteImage,
  Workwear: workwearImage,
};

const productImagesByKey = Object.fromEntries(
  Object.entries(productImages).map(([name, image]) => [normalizeImageKey(name), image]),
);

export function setDatabaseProductImages(products: Array<{ name: string; imageUrl?: string }>) {
  databaseProductImages = Object.fromEntries(products
    .filter((product) => product.imageUrl)
    .map((product) => [normalizeImageKey(product.name), product.imageUrl as string]));
}

export function getProductImage(product: string) {
  const key = normalizeImageKey(product);
  return databaseProductImages[key] ?? productImagesByKey[key] ?? riceImage;
}
